import { LandingPagesNavbar, LandingPagesFooter } from '@podus/ui';
import Hero from '../../components/landing/Hero';
import HeroImage from '../../components/landing/HeroImage';
import PodusAiFeatures from '../../components/landing/PodusAiFeatures';
import AboutSection from '../../components/landing/AboutSection';
import AiForJustice from '@/components/landing/AiForJustice';
import Audience from '@/components/landing/Audience';
import PodusFeatures from '@/components/landing/PodusFeatures';
import Glimpse from '@/components/landing/Glimpse';
import WhereWeAre from '@/components/landing/WhereWeAre';
import Testimonials from '@/components/landing/Testimonials';
import FAQ from '@/components/landing/FAQ';
import MultidoorSection from '@/components/landing/MultidoorSection';

export default function Home() {
    return (
        <div className="page-scroll-root bg-white">
            <LandingPagesNavbar product="podus-ai" />

            <main className="overflow-x-clip">
                {/* Shared relative container for hero image overlap into partners */}
                <div className="relative">
                    <div className="mx-auto max-w-[1920px]">
                        <Hero />
                        <HeroImage />
                    </div>
                    <PodusAiFeatures />
                </div>
                <div className="mx-auto max-w-[1920px]">
                    <AboutSection />
                    <AiForJustice />
                    <Audience />
                    <MultidoorSection />
                    <PodusFeatures />
                    <Glimpse />
                    <WhereWeAre />
                    <Testimonials />
                    <FAQ />
                </div>
            </main>

            <LandingPagesFooter />
        </div>
    );
}
